import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components/core/Button';
import { StickyJumpNav } from 'components/facility/StickyJumpNav/StickyJumpNav';
import useBodyClassName from 'hooks/useBodyClassName';

import './StickyReserveBar.scss';

export function StickyReserveBar({
	sections,
	activeSection,
	onTabClick,
	reserveLabel = 'Reserve for Free',
	onReserveClick,
}) {
	// Lets the shared Footer reserve clearance only while this bar is
	// actually mounted, instead of unconditionally on every page.
	useBodyClassName('has-sticky-reserve-bar');

	return (
		<div className="sticky-reserve-bar">
			<StickyJumpNav
				links={sections}
				activeLink={activeSection}
				onLinkClick={onTabClick}
			/>
			<Button
				className="sticky-reserve-button"
				onClick={onReserveClick}
			>
				{reserveLabel}
			</Button>
		</div>
	);
}

StickyReserveBar.propTypes = {
	sections: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
		}),
	).isRequired,
	activeSection: PropTypes.string,
	// Called as onTabClick(sectionId, event) - a plain handler, not a
	// curried factory.
	onTabClick: PropTypes.func.isRequired,
	reserveLabel: PropTypes.string,
	onReserveClick: PropTypes.func.isRequired,
};

export default StickyReserveBar;
